import { isDev } from './helpers'

export const HEADER_HEIGHT = 76
export const QUERY_KEYS = {
  versions: 'VERSIONS',
  model_access: 'MODEL_ACCESS',
  model_content: 'MODEL_CONTENT',
  model_metadata: 'MODEL_METADATA',
  model_groups: 'MODEL_GROUPS',
  model_claim: 'MODEL_CLAIM',
}

export const ROLES = Object.freeze({
  admin: 'admin',
  user: 'user',
  viewer: 'viewer',
  editor: 'editor',
})

export const WRANGLE_TYPES = Object.freeze({
  diy: 'diy',
  bespoke: 'bespoke',
  stock: 'stock',
})

export const WRANGLE_PURPOSES = {
  classify: 'classify',
  extract: 'extract',
  standardize: 'standardize',
  map: 'map',
  recipe: 'recipe',
  lookup: 'lookup',
}

export const DEFAULT_EDIT_ROLES: string[] = [ROLES.admin, ROLES.editor]

// Purposes shown as filter chips in Models.tsx. Purposes in BETA_PURPOSE_LIST
// are only shown to users with the 'beta' role.
export const BASE_PURPOSE_LIST = [
  'Classify',
  'Extract',
  'Standardize',
  'Lookup',
]
export const BETA_PURPOSE_LIST = ['Map', 'Recipe']

export const PURPOSE_STORAGE_KEYS = Object.freeze({
  filters: 'wrwx/wrangles/purposes',
  order: 'wrwx/wrangles/purposeOrder',
  hidden: 'wrwx/wrangles/hiddenPurposes',
})

// Dispatched on `window` when hidden purposes are changed in ModelSettings,
// so Models.tsx (a separate component tree) can react to the localStorage change.
export const PURPOSE_VISIBILITY_CHANGED_EVENT =
  'wrwx-purpose-visibility-changed'

export const RECIPE_VARIABLE_TYPES = Object.freeze({
  text: 'Text',
  multiText: 'Multiline Text',
  boolean: 'Boolean',
  number: 'Number',
  dropdown: 'Dropdown',
  date: 'Date',
  columns: 'Columns',
  file: 'File',
  function: 'Function',
  constant: 'Constant',
  list: 'List',
  dictionary: 'Dictionary',
})

export const TAG_VALIDATION_REGEX = /^[a-zA-Z0-9._-]*$/

export const RECIPE_SCHEMA_URL = isDev
  ? 'https://public.wrangle.works/schema/recipes/schema_dev.json'
  : 'https://public.wrangle.works/schema/recipes/schema.json'
